import React from "react";
import { Box, HStack, Text } from "@chakra-ui/react";

export const isPatientMessageSystemEvent = (message) =>
  message?.direction === "system";

const PatientMessageSystemEvent = ({ message, formattedTimestamp }) => (
  <HStack
    width="100%"
    justify="center"
    data-direction="system"
  >
    <Box
      bg="gray.100"
      color="gray.700"
      px={3}
      py={2}
      borderRadius="md"
      textAlign="center"
    >
      <Text fontSize="sm">{message}</Text>
      <Text fontSize="xs" color="gray.500" mt={1}>
        {formattedTimestamp}
      </Text>
    </Box>
  </HStack>
);

export default PatientMessageSystemEvent;
